module.exports = __webpack_public_path__ + "img/shipo-menu-reports.a2642edb.svg";